import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabColumnHeaderApi } from '../api/labcolumnheader.api';
import { switchMap, map } from 'rxjs/operators';

import { LabColumnHeader,LabColumnHeaderData } from '../../../interfaces/masters/labcolumnheader';


@Injectable()
export class LabColumnHeaderService extends LabColumnHeaderData{

  constructor(private api: LabColumnHeaderApi) {
    super();
  } 
  
  list(url: string): Observable<LabColumnHeader[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<LabColumnHeader>{
      return this.api.getById(url);
  }

  create(url: string, data:LabColumnHeader): Observable<LabColumnHeader[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:LabColumnHeader): Observable<LabColumnHeader> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

}
